import { useParams } from "react-router";
import { CustomerInformationForm } from "@/components/forms/customer-information-form";
import { Steps } from "@/components/steps";

export default function CustomerInformation() {
  const { service } = useParams();

  return (
    <div className="space-y-12">
      <Steps className="mx-auto flex max-w-2xl" currentStep={2} />

      <CustomerInformationForm
        className="space-y-12"
        serviceType={service as ServiceType}
      />
    </div>
  );
}
